module.exports = __webpack_public_path__ + "img/wizard-loader-1.6a7ca880.png";